import { ROBKeys } from "components/ROB/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

export const useROBSLA = (car_id: number, enabled: boolean) =>
  useTypedQuery({
    queryKey: ROBKeys.slas(car_id),
    queryFn: async ({ baseUrl, endpoint, params }) => (await ApiInstance.post(endpoint, params, baseUrl))?.data ?? null,
    enabled
  });
